import type { PosterFieldId } from './fields';
/** 独立字段的本地保存确认；真实接口和持久化尚未接入。 */
export function savePosterField(_id: PosterFieldId, _visible: boolean, signal: AbortSignal): Promise<void> {
  return new Promise((resolve, reject) => {
    if (signal.aborted) { reject(new DOMException('Aborted', 'AbortError')); return; }
    const abort = () => {
      clearTimeout(timer);
      signal.removeEventListener('abort', abort);
      reject(new DOMException('Aborted', 'AbortError'));
    };
    const timer = setTimeout(() => { signal.removeEventListener('abort', abort); resolve(); }, 300);
    signal.addEventListener('abort', abort, { once: true });
  });
}
